import * as React from 'react';
import useI18n from 'src/hooks/useI18n';
import {useDispatch} from 'react-redux';
import {useHistory} from 'src/rerouter/index';
import {popModal} from 'src/action-creators/modal';

import {
  Content,
  TextContent,
  Container,
  Buttons,
  Button,
  SuccessTitleBar,
} from './components';
import {
  ReportExportInit,
  ReportExportSuccess,
} from 'src/components/common/reports/data-export-success-genesis';

import css from './base-modal.css';


export const DefaultContent = () => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  return (
    <>
      <p>{`${t(
        'When_your_requested_report_is_ready_for_download_you_will_receive_an_email_with_a_download_link',
        'When your requested report is ready for download, you will receive an email with a download link',
      )}. ${t(
        'While_estimated_times_are_varied_we_expect_it_will_be_ready_soon',
        'While estimated times are varied, we expect it will be ready soon',
      )}.`}</p>
      <p>
        {`${t(
          'To_find_all_past_reports_navigate_to_the_Reports_tab_within_Settings',
          'To find all past reports, navigate to the Reports tab within Settings',
        )}.`}
        {`(${t('Settings', 'Settings')}`} &#8594;{' '}
        {`${t('Reports', 'Reports')})`}
      </p>
      <p>{`${t(
        'If_you_do_not_receive_an_email_check_your_spam_folder_or_request_the_report_again',
        'If you do not receive an email, check your spam folder or request the report again',
      )}.`}</p>
    </>
  );
};

export function DataExportInit({
  removeModal,
  CustomContent,
  modalVersion,
}: {
  removeModal: () => unknown;
  CustomContent?: string | React.ReactNode;
  modalVersion?: 'genesis';
}) {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  const router = useHistory();
  const closePreviousModal = useClosePreviousModal();

  if (modalVersion === 'genesis') {
    return (
      <ReportExportInit
        CustomContent={CustomContent}
        handlePrimaryCta={() => {
          removeModal();
          closePreviousModal();
        }}
        handleSecondaryCta={() => {
          removeModal();
          closePreviousModal();
        }}
      />
    );
  }
  return (
    // @ts-expect-error - TS2322 - Type 'string | React.ReactNode' is not assignable to type 'never'.
    <Container>
      <SuccessTitleBar>
        {t('Request_successful', 'Request successful')}
      </SuccessTitleBar>
      {/* @ts-expect-error - TS2322 - Type 'string | React.ReactNode' is not assignable to type 'never'. */}
      <Content>
        {/* @ts-expect-error - TS2322 - Type 'string | React.ReactNode' is not assignable to type 'never'. */}
        <TextContent className={css.successText}>
          {CustomContent ? CustomContent : <DefaultContent />}
        </TextContent>
        {/* @ts-expect-error - TS2322 - Type 'string | React.ReactNode' is not assignable to type 'never'. */}
        <Buttons>
          <Button
            onClick={() => {
              router.push('/settings/reports');
              removeModal();
              closePreviousModal();
            }}
          >
            {t('View_reports', 'View reports')}
          </Button>
          <Button type="primary" onClick={removeModal}>
            {t('Okay', 'Okay')}
          </Button>
        </Buttons>
      </Content>
    </Container>
  );
}

export function DataExportSuccess({
  removeModal,
  modalVersion,
}: {
  removeModal: () => unknown;
  modalVersion?: 'genesis';
}) {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  const router = useHistory();
  const closePreviousModal = useClosePreviousModal();

  if (modalVersion === 'genesis') {
    return (
      <ReportExportSuccess
        handlePrimaryCta={() => {
          removeModal();
          closePreviousModal();
        }}
        handleSecondaryCta={() => {
          removeModal();
          closePreviousModal();
        }}
      />
    );
  }

  return (
    // @ts-expect-error - TS2322 - Type 'string | React.ReactNode' is not assignable to type 'never'.
    <Container>
      <SuccessTitleBar>{t('Report_ready', 'Report ready')}</SuccessTitleBar>
      {/* @ts-expect-error - TS2322 - Type 'string | React.ReactNode' is not assignable to type 'never'. */}
      <Content>
        {/* @ts-expect-error - TS2322 - Type 'string | React.ReactNode' is not assignable to type 'never'. */}
        <TextContent className={css.successText}>
          <p>{`${t('Your_report_is_ready', 'Your report is ready')}. ${t(
            'You_can_download_it_by_navigating_to_the_Reports_page',
            'You can download it by navigating to the Reports page',
          )}.`}</p>
        </TextContent>
        {/* @ts-expect-error - TS2322 - Type 'string | React.ReactNode' is not assignable to type 'never'. */}
        <Buttons>
          <Button
            onClick={() => {
              router.push('/settings/reports');
              removeModal();
              closePreviousModal();
            }}
          >
            {t('View_reports', 'View reports')}
          </Button>
          <Button type="primary" onClick={removeModal}>
            {t('Okay', 'Okay')}
          </Button>
        </Buttons>
      </Content>
    </Container>
  );
}

const useClosePreviousModal = () => {
  const dispatch = useDispatch();
  const closePreviousModal = React.useCallback(() => {
    //(diwakersurya) this closes previous modal whether its
    // a side panel or modal.
    dispatch(popModal());
  }, []);
  return closePreviousModal;
};
